// please be familiar with react-bootstrap-table-next column formaters
// https://react-bootstrap-table.github.io/react-bootstrap-table2/storybook/index.html?selectedKind=Work%20on%20Columns&selectedStory=Column%20Formatter&full=0&addons=1&stories=1&panelRight=0&addonPanel=storybook%2Factions%2Factions-panel
import React from "react";
import {
  OfferStatusCssClasses,
  OfferStatusTitles,
} from "../../OffersUIHelpers";

export function StatusColumnFormatter(cellContent, row) {
  let x=1;
  if(row.type==="canceled") {
    x=0;
  } else if(row.type==="on-hold") {
    x=2;
  }
  else if(row.type==="pending") {
    x=3;
  }
  const getLabelCssClasses = () => {
    return `label label-lg label-light-${
      OfferStatusCssClasses[x]
    } label-inline`;
  };
  return (
    <span className={getLabelCssClasses()}>
      {OfferStatusTitles[x]}
    </span>
  );
}


